































































































import FormPayment from '@/app/shared/components/forms/payment.vue';
import {
  CardChangerModel,
  CreditModel,
  DebitModel,
  PaymentInfoModel,
  VForm,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { FormPayment } })
export default class DialogPaymentComponent extends Vue {
  @Ref() private form!: VForm;
  @Prop(Boolean) readonly value!: boolean;

  private valueTab = '';
  private paymentInfo1: PaymentInfoModel = new PaymentInfoModel();
  private paymentInfo2: PaymentInfoModel = new PaymentInfoModel();
  private twoPaymentInfo = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private get getPaymentInfo2Exist() {
    return Object.keys(this.paymentInfo2).length == 0 || !this.paymentInfo2
      ? false
      : true;
  }

  private removePaymentInfo2() {
    this.twoPaymentInfo = false;
    this.paymentInfo2 = new PaymentInfoModel();
  }

  private async savePaymentInfo(updatePaymentInfoContractInstallment: boolean) {
    if (this.form && !this.form.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.form && this.form.validate()) {
      const payments = [this.refs._.cloneDeep(this.paymentInfo1)];

      // Não irá utilizar 2º método de pagamento por enquanto
      // if (this.getPaymentInfo2Exist) {
      //   payments.push(this.refs._.cloneDeep(this.paymentInfo2));
      // }

      const data = {
        contractId: this.refs.modules.contract.contract.Id,
        paymentInfo: payments,
        descReason: this.valueTab,
      };

      data.paymentInfo.map((payment) => {
        payment.UpdatePaymentInstallmentContract = updatePaymentInfoContractInstallment;
      });

      await this.addCard(payments)
        .then(async (newPayments) => {
          const apportionmentType = this.refs.enums.ApportionmentType.Percent;
          const apportionmentValue = 100 / newPayments.length;
          data.paymentInfo = newPayments;
          data.paymentInfo.map((paymentInfo) => {
            paymentInfo.ApportionmentType = apportionmentType;
            paymentInfo.ApportionmentValue = apportionmentValue;
          });

          if (
            newPayments.length > 0 &&
            data.paymentInfo.length == newPayments.length
          ) {
            if (
              this.refs.enums.PaymentDestination[
                this.refs.modules.contract.paymentDestination
              ] ==
                this.refs.enums.PaymentDestination[
                  this.refs.enums.PaymentDestination.Parcel
                ] &&
              (this.refs.enums.PaymentMethod[
                data.paymentInfo[0].PaymentMethod
              ] == this.refs.enums.PaymentMethod.BankSlip.toString() ||
                this.refs.enums.PaymentMethod[
                  data.paymentInfo[0].PaymentMethod
                ] == this.refs.enums.PaymentMethod.BRCode.toString())
            ) {
              const installmentId = this.refs.modules.contract.installment.Id;
              if (installmentId === undefined) return;

              const data = {
                contractId: this.refs.modules.contract.contract.Id,
                paymentInfo: payments,
                installmentId: installmentId,
                descReason: this.valueTab,
              };
              await this.refs.modules.contract
                .updatePaymentMethod(data)
                .then(async () => {
                  this.$toast(
                    this.$t('toasts.change_payment_method_successfully')
                  );
                  this.refs.modules.ticket.SET_EDIT_PAYMENT_METHOD(true);

                  await this.refs.modules.contract.loadInstallmentList(
                    this.$route.params.id
                  );
                  await this.refs.modules.contract
                    .loadPaymentInfoByContractId(this.$route.params.id)
                    .then(() => {
                      localStorage.removeItem('tabulacao');
                      this.$bus.$emit('cleanValueTab');
                    });
                  this.$emit('close');
                })
                .catch((err) => {
                  this.refs.util.showErrors(err);
                  // this.$toast.error('ERROR ? ', err);
                  // this.$toast.error(this.$t('toasts.change_payment_method_error'));
                });
            } else {
              await this.refs.modules.contract
                .updatePaymentInfo(data)
                .then(async () => {
                  this.$toast(
                    this.$t('toasts.change_payment_method_successfully')
                  );
                  this.refs.modules.ticket.SET_EDIT_PAYMENT_METHOD(true);
                  await this.refs.modules.contract.loadInstallmentList(
                    this.$route.params.id
                  );
                  await this.refs.modules.contract
                    .loadPaymentInfoByContractId(this.$route.params.id)
                    .then(() => {
                      localStorage.removeItem('tabulacao');
                      this.$bus.$emit('cleanValueTab');
                    });
                  this.$emit('close');
                })
                .catch((err) => {
                  this.refs.util.showErrors(err);
                  // this.$toast.error('ERROR ? ', err);
                  // this.$toast.error(this.$t('toasts.change_payment_method_error'));
                });
            }
          } else {
            this.$toast.error(this.$t('toasts.credit_card_save_error'));
          }
        })
        .catch((err) => {
          this.refs.util.showErrors(err);
        });
    }
  }
  private async addCard(payments: PaymentInfoModel[]) {
    const newPayments = [] as PaymentInfoModel[];
    await Promise.all(
      payments.map(async (payment) => {
        if (
          this.refs.enums.PaymentMethod[payment.PaymentMethod] ==
          this.refs.enums.PaymentMethod.Credit.toString()
        ) {
          (
            payment.Credit || new PaymentInfoModel()
          ).CardExpiration = this.refs
            .moment(
              (payment.Credit || new PaymentInfoModel()).CardExpiration,
              'MMYYYY'
            )
            .format('YYYYMM');

          const card = new CardChangerModel();
          card.CardNumber = (
            payment.Credit || new PaymentInfoModel()
          ).CardTruncatedNumber;
          card.CardExpiration = (
            payment.Credit || new PaymentInfoModel()
          ).CardExpiration;
          card.CardKey = (payment.Credit || new PaymentInfoModel()).CardKey;
          card.CardHolder = (
            payment.Credit || new PaymentInfoModel()
          ).CardHolder;
          card.CardBrand = (payment.Credit || new PaymentInfoModel()).CardBrand;
          await this.refs.modules.contract
            .addCardChanger(card)
            .then((response) => {
              if (response.ok) {
                (payment.Credit || new PaymentInfoModel()).CardKey =
                  response.cardKey;
                newPayments.push(payment);
              } else {
                this.$toast.error(this.$t('toasts.credit_card_save_error'));
                return;
              }
            })
            .catch((error) => {
              this.$toast.error('ERROR ? ', error);
              this.$toast.error(this.$t('toasts.credit_card_save_error'));
              return;
            });
        } else {
          newPayments.push(payment);
        }
      })
    );
    return newPayments;
  }

  @Watch('value')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value && this.form) this.form.resetValidation();
    if (value) {
      if (
        this.refs.enums.PaymentDestination[
          this.refs.modules.contract.paymentDestination
        ] ==
        this.refs.enums.PaymentDestination[
          this.refs.enums.PaymentDestination.Parcel
        ]
      ) {
        const installmentId = this.refs.modules.contract.installment.Id;
        if (installmentId === undefined) return;

        this.refs.modules.contract
          .loadPaymentInfoByInstallmentId({
            contractId: this.refs.modules.contract.contract.Id,
            installmentId,
          })
          .then(() => {
            this.paymentInfo1 = this.refs._.clone(
              this.refs.modules.contract.paymentInfo[0]
            );
            if (this.refs.modules.contract.paymentInfo[1]) {
              this.paymentInfo2 = this.refs._.clone(
                this.refs.modules.contract.paymentInfo[1]
              );
            }
            if (
              this.refs.enums.PaymentMethod[this.paymentInfo1.PaymentMethod] ==
              this.refs.enums.PaymentMethod.Credit.toString()
            )
              this.$set(this.paymentInfo1, 'Credit', new CreditModel());
            else if (
              this.refs.enums.PaymentMethod[this.paymentInfo1.PaymentMethod] ==
              this.refs.enums.PaymentMethod.Debit.toString()
            )
              this.$set(this.paymentInfo1, 'Debit', new DebitModel());

            // Não irá utilizar 2º método de pagamento por enquanto
            // if (this.paymentInfo2) {
            //   if (
            //     this.refs.enums.PaymentMethod[
            //       this.paymentInfo2.PaymentMethod
            //     ] == this.refs.enums.PaymentMethod.Credit.toString()
            //   )
            //     this.$set(this.paymentInfo2, 'Credit', new CreditModel());
            //   else if (
            //     this.refs.enums.PaymentMethod[
            //       this.paymentInfo2.PaymentMethod
            //     ] == this.refs.enums.PaymentMethod.Debit.toString()
            //   )
            //     this.$set(this.paymentInfo2, 'Debit', new DebitModel());
            // }
          });
      } else {
        this.paymentInfo1 = this.refs._.clone(
          this.refs.modules.contract.paymentInfo[0]
        );
        if (this.refs.modules.contract.paymentInfo[1]) {
          this.paymentInfo2 = this.refs._.clone(
            this.refs.modules.contract.paymentInfo[1]
          );
        }
        if (
          this.paymentInfo1 &&
          this.refs.enums.PaymentMethod[this.paymentInfo1.PaymentMethod] ==
            this.refs.enums.PaymentMethod.Credit.toString()
        )
          this.$set(this.paymentInfo1, 'Credit', new CreditModel());
        else if (
          this.paymentInfo1 &&
          this.refs.enums.PaymentMethod[this.paymentInfo1.PaymentMethod] ==
            this.refs.enums.PaymentMethod.Debit.toString()
        )
          this.$set(this.paymentInfo1, 'Debit', new DebitModel());

        // Não irá utilizar 2º método de pagamento por enquanto
        // if (this.paymentInfo2) {
        //   if (
        //     this.refs.enums.PaymentMethod[this.paymentInfo2.PaymentMethod] ==
        //     this.refs.enums.PaymentMethod.Credit.toString()
        //   )
        //     this.$set(this.paymentInfo2, 'Credit', new CreditModel());
        //   else if (
        //     this.refs.enums.PaymentMethod[this.paymentInfo2.PaymentMethod] ==
        //     this.refs.enums.PaymentMethod.Debit.toString()
        //   )
        //     this.$set(this.paymentInfo2, 'Debit', new DebitModel());
        // }
      }
    }
  }
}
